export default __webpack_public_path__ + "static/media/department-image.86de3d0a.png";